import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, getRouteApi } from "@tanstack/react-router";
// UI
import { LoginForm, type LoginFormValues } from "./login-form";
import { Card, Title, Container } from "@mantine/core";
// API
import { backendApi } from "src/backendApi/backendApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userInfoQueryOpts } from "src/services/apiQueries/userQueries";

const route = getRouteApi("/login");

export const LoginPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { next: nextUri } = route.useSearch();

  const mutation = useMutation({
    mutationKey: ["SESSION_LOGIN"],
    mutationFn: async (values: LoginFormValues) => {
      const { username, password } = values;
      await backendApi.sessionAuthLogin(username, password);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: userInfoQueryOpts().queryKey,
      });

      if (nextUri) {
        await navigate({ to: nextUri });
      }

      const userInfo = await queryClient.ensureQueryData(userInfoQueryOpts());

      await navigate({
        to: "/app/accounts/$accountId/players",
        params: {
          accountId: userInfo.account.id.toString(),
        },
      });
    },
    onError: async () => {},
  });

  const handleSubmit = mutation.mutateAsync;

  return (
    <Container py="10%">
      <Title ta="center" mb="md">
        {t("loginPage.header")}
      </Title>

      <Card withBorder p="xl" mt="xl">
        <LoginForm onSubmit={handleSubmit} isError={mutation.isError} />
      </Card>
    </Container>
  );
};
